import { render } from "./family-info.vue?vue&type=template&id=41226c8b&scoped=true"
import script from "./family-info.vue?vue&type=script&lang=js"
export * from "./family-info.vue?vue&type=script&lang=js"

import "./family-info.vue?vue&type=style&index=0&id=41226c8b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41226c8b"]])

export default __exports__